import { Box, Divider, Typography } from '@mui/material'

export default function ViewHeader({
  header,
  subheader
}: {
  header: string
  subheader: string
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '.5rem',
        paddingBottom: '1rem',
        width: '100%'
      }}
    >
      <Typography variant='h4'>{header}</Typography>
      <Typography variant='body1'>{subheader}</Typography>
      <Divider />
    </Box>
  )
}
